import { render, staticRenderFns } from "./admin-education-language.vue?vue&type=template&id=3fa42bf6&scoped=true"
import script from "./admin-education-language.vue?vue&type=script&lang=js"
export * from "./admin-education-language.vue?vue&type=script&lang=js"
import style0 from "./admin-education-language.vue?vue&type=style&index=0&id=3fa42bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa42bf6",
  null
  
)

export default component.exports